<template>
  <content>

        <!--------------------------------->
        <!--            Header           -->
        <!--------------------------------->
    <v-row
      class="mt-12 mb-10"
      no-gutters
    >
      <v-col
        class="text-center ma-0 pa-0"
        cols="12"
        style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
      >
        IT'S AS EASY AS...
      </v-col>
    </v-row>
    
        <!--           Divider           -->
    <v-row
      class="mb-10"
      justify="center"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
        xs="12"
        sm="8"
        md="6"
        lg="4"
        xl="4"
      >
        <v-divider
          color="#424242"
        >
        </v-divider>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--          Steps xs-          -->
        <!--------------------------------->
    <v-row
      justify="center"
      class="text-center mx-5 mb-5 d-sm-none"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
      >

      <!--           Step 1            -->
        <v-row
          class="ma-0 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              1. tell us what you like
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/phone.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
            >
              Customize your profile with the kind of food you like, your weight goals, allergies or restrictions, and even your weekly budget! Have family members with different goals and tastes? Not a problem, you can personalize your profile for everyone at the table.
            </v-row>
          </v-col>
        </v-row>

    <!--           Step 2            -->
        <v-row
          class="my-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
                justify="center"
                no-gutters
                style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
              >
              2. get your custom menu
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/ipad.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
                justify="center"
                no-gutters
                style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
              >
              We then create a full week's menu with delicious, easy meals that match your preferences perfectly. breakfast, lunch, dinner and even snacks all planned with a shopping list ready to go. Don't have time to shop? We've got you covered there too with online ordering options available in just a few clicks.  
            </v-row>
          </v-col>
        </v-row>

        <!--           Step 3            -->
        <v-row
          class="ma-0 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              3. shop, cook & enjoy
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/enjoy.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
            >
              Cheers to to never having to stress about what's for dinner again! You're now stocked with the exact ingredients you need to make meals that fit your lifestyle perfectly. All you have to do is cook it and soak up that extra time you saved. 
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


        <!--------------------------------->
        <!--          Steps sm+          -->
        <!--------------------------------->
    <v-row
      justify="center"
      class="text-center mb-5 d-none d-sm-flex"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
        xs="12"
        sm="11"
        md="8"
        lg="7"
        xl="6"
      >

      <!--           Step 1            -->
        <v-row
          class="mt-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-img
              src="@/assets/main/phone.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              1
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              tell us what you like
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              Customize your profile with the kind of food you like, your weight goals, allergies or restrictions, and even your weekly budget! Have family members with different goals and tastes? Not a problem, you can personalize your profile for everyone at the table.
            </v-row>
          </v-col>
        </v-row>

    <!--           Step 2            -->
        <v-row
          class="my-12 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              2
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              get your custom menu
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              We then create a full week's menu with delicious, easy meals that match your preferences perfectly. breakfast, lunch, dinner and even snacks all planned with a shopping list ready to go. Don't have time to shop? We've got you covered there too with online ordering options available in just a few clicks.  
            </v-row>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-img
              src="@/assets/main/ipad.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
        </v-row>

        <!--           Step 3            -->
        <v-row
          class="mb-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-img
              src="@/assets/main/enjoy.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              3
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              shop, cook & enjoy
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              Cheers to to never having to stress about what's for dinner again! You're now stocked with the exact ingredients you need to make meals that fit your lifestyle perfectly. All you have to do is cook it and soak up that extra time you saved. 
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->
    <freeTrial
      class="mt-10"
    />
    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->

        <!--------------------------------->
        <!--         Explanation         -->
        <!--------------------------------->
    <v-row
      class="mt-5 mb-10"
      no-gutters
    >
      <div
        class="bg3"
      >
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="d-none d-sm-flex my-10 px-0 text-center"
            style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            cols="12"
            xs="12"
            sm="11"
            md="6"
            lg="5"
            xl="4"
          >
            A MEAL PLANNING APP THAT'S THOUGHT OF EVERYTHING, FINALLY.
          </v-col>
          <v-col
            class="d-sm-none my-10 px-3 text-center"
            style="font-size: 1.4em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            cols="12"
            xs="12"
            sm="11"
            md="6"
            lg="5"
            xl="4"
          >
            A MEAL PLANNING APP THAT'S THOUGHT OF EVERYTHING, FINALLY.
          </v-col>
        </v-row>
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="mb-10 pa-0"
            cols="12"
            xs="12"
            sm="11"
            md="8"
            lg="7"
            xl="6"
          >
            <v-row
              justify="center"
              no-gutters
            >

        <!--        Nutritionist         -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/nutritionist.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    NUTRITIONIST
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  justify="center"
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  We create the perfect weekly meal plans and tell you exactly how many calories, macros and proportion sizes to eat so you can meet your goals without any of the headache. Oh, and we also keep track of everything so you don't have to. 
                </v-row>
              </v-col>

        <!--          Assistant          -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/assistant.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    ASSISTANT
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  It's like having a second you in the kitchen. We learn what you like and don't like with each recipe you cook to give you true, custom meals you know you'll love without the work. You can also add your own recipes, create recurring dinner themes and even holiday menus!
                </v-row>
              </v-col>

          <!--         Meal Planner        -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/planner.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    MEAL PLANNER
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  How about a full day's meals and snacks pre-planned for you and the entire family each week without even having to think about it? Yea, that's exactly what we deliver. No limited options here, we have thousands of recipes and accommodate all major diets. 
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->
        <freeTrial
          class="mt-5"
        />
    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->

        <!--------------------------------->
        <!--How About Getting Used To xs -->
        <!--------------------------------->
        <v-row
          class="d-sm-none"
          justify="center"
          no-gutters
        >
          <v-col>
            <v-row
              class="mt-5 mb-1"
              justify="center"
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 1px;"
              no-gutters
            >
              <v-col
                class="text-center mx-3 pa-0"
                cols="12"
              >
                HOW ABOUT GETTING USED TO
              </v-col>
            </v-row>

            <v-row
              class="mb-10"
              no-gutters
            >
              <div
                class="bg4"
              >
                <v-row
                justify="center"
                no-gutters
                >
                  <v-col
                    class="my-10 mx-5 pa-0 text-center"
                    cols="12"
                    xs="12"
                    sm="11"
                    md="8"
                    lg="7"
                    xl="6"
                  >
                    <div>
                      <v-row
                        no-gutters
                      >
                        <v-col
                          class="mx-3"
                        >

              <!--  meeting your weight goals  -->
                          <v-row
                            class="mb-1"
                            no-gutters
                            align="center"
                            justify="center"
                          >
                            <v-img
                              src="@/assets/main/scale.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            meeting your weight goals
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Know exactly how much to eat each meal to reach your goals. We make it easy by calculating portions and macros to get you there without the headache.
                          </v-row>

              <!--    staying in your budget   -->
                          <v-row
                            class="mt-10 mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/piggy-bank.png"
                              style="max-width: 40px;"
                              class="ml-2"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            staying in your grocery budget
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            No need to add up totals in your head, with estimated recipe costs included with each menu it's easy to stay within your budget and still have a full week of delicious meals.
                          </v-row>
                        </v-col>

                        <v-col
                          class="mx-3"
                        >
              <!--      never wasting food     -->
                          <v-row
                            class="mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/earth.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            never wasting food
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            We portion each recipe perfectly so you'll never have wasted leftovers sitting around. Every meal is accounted for with Smart Food Planner.
                          </v-row>

              <!--  time for what matters most -->
                          <v-row
                            class="mt-10 mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/ribbon.png"
                              style="max-width: 40px;"
                              class="ml-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            more time for what matters
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Hang out with your family, spend time crushing your goals or get that much needed relax time in. However you spend the time you saved using Smart Food Planner, we're sure you'll enjoy it. 
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>        
              </div>
            </v-row>
          </v-col>
        </v-row>

        <!--------------------------------->
        <!--How About Getting Used To sm+-->
        <!--------------------------------->
        <v-row
          class="d-none d-sm-flex"
          justify="center"
          no-gutters
        >
          <v-col>
            <v-row
              class="mt-5 mb-1"
              justify="center"
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 1px;"
              no-gutters
            >
              <v-col
                class="text-center mx-3 pa-0"
                cols="12"
              >
                HOW ABOUT GETTING USED TO
              </v-col>
            </v-row>

            <v-row
              class="mb-10"
              no-gutters
            >
              <div
                class="bg4"
              >
                <v-row
                justify="center"
                no-gutters
                >
                  <v-col
                    class="my-10 mx-5 pa-0 text-center"
                    cols="12"
                    xs="12"
                    sm="11"
                    md="8"
                    lg="7"
                    xl="6"
                  >
                    <div>
                      <v-row
                        no-gutters
                      >
                        <v-col
                          class="ml-3 mr-12"
                        >

              <!--  meeting your weight goals  -->
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            <v-img
                              src="@/assets/main/scale.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                            meeting your weight goals
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Know exactly how much to eat each meal to reach your goals. We make it easy by calculating portions and macros to get you there without the headache.
                          </v-row>

              <!--    staying in your budget   -->
                          <v-row
                            class="mt-10 mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            staying in your grocery budget
                            <v-img
                              src="@/assets/main/piggy-bank.png"
                              style="max-width: 40px;"
                              class="ml-2"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            No need to add up totals in your head, with estimated recipe costs included with each menu it's easy to stay within your budget and still have a full week of delicious meals.
                          </v-row>
                        </v-col>

                        <v-col
                          class="ml-12 mr-3"
                        >
              <!--      never wasting food     -->
                          <v-row
                            class="mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            <v-img
                              src="@/assets/main/earth.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                            never wasting food
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            We portion each recipe perfectly so you'll never have wasted leftovers sitting around. Every meal is accounted for with Smart Food Planner.
                          </v-row>

              <!--  time for what matters most -->
                          <v-row
                            class="mt-10 mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            more time for what matters most
                            <v-img
                              src="@/assets/main/ribbon.png"
                              style="max-width: 40px;"
                              class="ml-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Hang out with your family, spend time crushing your goals or get that much needed relax time in. However you spend the time you saved using Smart Food Planner, we're sure you'll enjoy it. 
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>        
              </div>
            </v-row>
          </v-col>
        </v-row>

        <!--       End Explanation       -->
      </div>
    </v-row>



  </content>
</template>

<script>
  import freeTrial from '@/components/login/startFreeTrialButton.vue'

export default {
  components: {
    freeTrial
  },

}
</script>


<style scoped>
  .bg3 {
    background: #f4f4f4;
    height: 425px;
    width: 100%;
  }

  .bg4 {
    background: url(../assets/main/background4.png);
    height: min-content;
    width: 100%;
    background-size: cover;
    background-position: center center;
  }

  .label1 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.8em;
    font-weight: 300;
    height: 24px;
    width: 130px;
    color: #ffffff;
    background: #a3e85f;
    text-align: center;
    padding: 3px 0px 0px 0px;
    position: relative;
    top: -12px;
  }

</style>